import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import HomePage from "@/pages/HomePage";
import SearchResultsPage from "@/pages/SearchResultsPage";
import FacilityPage from "@/pages/FacilityPage";
import FacilitiesListPage from "@/pages/FacilitiesListPage";
import TravelerAlertPage from "@/pages/TravelerAlertPage";
import MapPage from "@/pages/MapPage";
import JurisdictionsPage from "@/pages/JurisdictionsPage";
import TrackerPage from "@/pages/TrackerPage";
import TrackerResultPage from "@/pages/TrackerResultPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    document.title = "US Prisoner & Institution Status";
  }, []);
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="min-h-screen flex flex-col bg-slate-50 overflow-x-hidden">
            <NavBar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/search" element={<SearchResultsPage />} />
                <Route path="/facilities" element={<FacilitiesListPage />} />
                <Route path="/facility/:id" element={<FacilityPage />} />
                <Route path="/map" element={<MapPage />} />
                <Route path="/jurisdictions" element={<JurisdictionsPage />} />
                <Route path="/tracker" element={<TrackerPage />} />
                <Route path="/traveler-alert" element={<TravelerAlertPage />} />
                <Route path="/travel-alert" element={<Navigate to="/traveler-alert" replace />} />
                <Route path="/tracker/success" element={<TrackerResultPage success={true} />} />
                <Route path="/tracker/cancel" element={<TrackerResultPage success={false} />} />
                <Route path="/admin" element={<AdminLoginPage />} />
                <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
              </Routes>
            </main>
            <Footer />
            <Toaster richColors position="top-right" />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
